// extracted by mini-css-extract-plugin
var _1 = "Zv33ufUVElGHy0elkwWI";
export { _1 as "row" }
